const siteSupervisionData = {
  topSection: {
    headingText: "Build with",
    highlightedText: "confidence",
    subText: "Expert supervision for your dream project",
    headingText2: "",
    video: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fvideo.mp4?alt=media&token=c22a3b84-0c76-4dc8-bb50-7a0c41728650"
  },

  features: [
    {
      title: 'On-site inspections',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fkey-features%2F1.png?alt=media&token=d4e13a4f-2a47-4229-8051-010ceaaf947f"
    },
    {
      title: 'Issue identification and resolution',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fkey-features%2F2.png?alt=media&token=52a991e9-1cc9-42cb-afbe-27f473f997f5"
    },
    {
      title: 'Coordination with contractors',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fkey-features%2F3.png?alt=media&token=917d6ab9-66b1-43c3-9a32-db3d225efc92"
    },
    {
      title: 'Regular client updates',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fkey-features%2F3.png?alt=media&token=917d6ab9-66b1-43c3-9a32-db3d225efc92"
    },
  ],

  numbers: [
    { number: 50, label: 'Interior Experts', symbol: '+', duration: 2500 },
    { number: 60, label: 'Location Served', symbol: '+', duration: 2500 },
    { number: 1000, label: 'Happy Clients', symbol: '+', duration: 2500 },
  ],

  stepsData: [
    {
      title: 'Initial Consultation',
      description: 'Understand project scope and client needs.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F1.png?alt=media&token=e413f092-1dd5-45c9-a9f4-67137096768d"
    },
    {
      title: 'Site Assessment',
      description: 'Conduct thorough site evaluation.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F2.png?alt=media&token=e9c1e5a3-43c3-4106-9134-d88ee7567626"
    },
    {
      title: 'Planning & Scheduling',
      description: 'Develop detailed supervision plan.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F3.png?alt=media&token=c5966993-47bb-415b-86a4-3f83b733cd4f"
    },
    {
      title: 'On-Site Supervision',
      description: 'Monitor construction progress daily.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F4.png?alt=media&token=64bce909-c690-493f-b242-ca2402ad17c1"
    },
    {
      title: 'Quality Inspections',
      description: 'Regular checks to ensure quality standards.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F5.png?alt=media&token=093c6c1a-72a6-4347-a117-bf0c09810d3f"
    },
    {
      title: 'Reporting',
      description: 'Provide comprehensive reports to clients.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F6.png?alt=media&token=eb3853b4-06aa-4046-99c4-3f165373e375"
    },
  ],
  
  stepData: [
    {
      number:1,
      title: 'Initial Consultation',
      description: 'Understand project scope and client needs.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F1.png?alt=media&token=e413f092-1dd5-45c9-a9f4-67137096768d"
    },
    {
      number:2,
      title: 'Site Assessment',
      description: 'Conduct thorough site evaluation.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F2.png?alt=media&token=e9c1e5a3-43c3-4106-9134-d88ee7567626"
    },
    {
      number:3,
      title: 'Planning & Scheduling',
      description: 'Develop detailed supervision plan.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F3.png?alt=media&token=c5966993-47bb-415b-86a4-3f83b733cd4f"
    },
    {
      number:4,
      title: 'On-Site Supervision',
      description: 'Monitor construction progress daily.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F4.png?alt=media&token=64bce909-c690-493f-b242-ca2402ad17c1"
    },
    {
      number:5,
      title: 'Quality Inspections',
      description: 'Regular checks to ensure quality standards.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F5.png?alt=media&token=093c6c1a-72a6-4347-a117-bf0c09810d3f"
    },
    {
      number:6,
      title: 'Reporting',
      description: 'Provide comprehensive reports to clients.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FSiteSupervisionAudit%2Fhow-it-works%2F6.png?alt=media&token=eb3853b4-06aa-4046-99c4-3f165373e375"
    },
  ],

  faqs: [
    {
      question: 'How often should a site supervisor be present on the construction site?',
      answer:
        'A site supervisor should conduct regular site visits, at least weekly, to monitor progress, verify compliance, check quality, and be present for key milestones and inspections.',
    },
    {
      question: 'How does a site supervisor ensure construction site safety?',
      answer:
        'A site supervisor ensures site safety by verifying compliance with safety regulations, making sure workers have protective gear, identifying hazards, and promoting a safety culture through training and enforcement.',
    },
    {
      question: 'What is a quality audit in construction?',
      answer:
        'A quality audit is a structured, independent process to ensure project activities comply with organizational policies and procedures, preventing quality issues and suggesting improvements.',
    },
    {
      question: 'How does a site supervisor manage subcontractors on the project?',
      answer:
        'A site supervisor manages subcontractors by clearly defining responsibilities, holding regular meetings, monitoring performance, ensuring documentation, and verifying quality and schedule adherence.',
    },
  ],
  reviews: [
    {
      review: "Outstanding design. They captured our vision with precision and efficiency. Highly satisfied!",
      name: "Mitali Sinha",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fmitali-sinha.jpeg?alt=media&token=9c952e12-04e5-454c-a2d7-3f8796706891",
      rating: 5
    },
    {
      review: "Transformed our space beautifully. A seamless process from start to finish. Highly recommended.",
      name: "P. Gowda",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
      rating: 4
    },
    {
      review: "They listened, they delivered. Impressed by their service.",
      name: "Nitin Prajapat",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fnitin-prajapat.jpeg?alt=media&token=f783369b-6c53-4c80-82eb-8a86e89debef",
      rating: 4
    },
    {
      review: "Fantastic architecture design & affordable.",
      name: "Snehal Raj",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fsnehal-raj.jpeg?alt=media&token=8937fcad-9cff-4196-9bde-9b114eea6990",
      rating: 5
    },
  ],
  review: [
    {
      quote: "Outstanding design. They captured our vision with precision and efficiency. Highly satisfied!",
      name: "Mitali Sinha",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fmitali-sinha.jpeg?alt=media&token=9c952e12-04e5-454c-a2d7-3f8796706891",
      rating: 5
    },
    {
      quote: "Transformed our space beautifully. A seamless process from start to finish. Highly recommended.",
      name: "P. Gowda",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
      rating: 4
    },
    {
      quote: "They listened, they delivered. Impressed by their service.",
      name: "Nitin Prajapat",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fnitin-prajapat.jpeg?alt=media&token=f783369b-6c53-4c80-82eb-8a86e89debef",
      rating: 4
    },
    {
      quote: "Fantastic architecture design & affordable.",
      name: "Snehal Raj",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fsnehal-raj.jpeg?alt=media&token=8937fcad-9cff-4196-9bde-9b114eea6990",
      rating: 5
    },
  ]
};

export default siteSupervisionData;
